import { Fragment, FunctionComponent } from 'react';
import { DraftConfiguration } from '@/types';
import { getIsSpecialPatternColor } from '../utils/getIsSpecialPatternColor';
import { getPatternId } from '../utils/getPatternId';
import { getPatternImageHref } from '../utils/getPatternImageHref';

interface PatternListProps {
  configuration: DraftConfiguration;
  width: number;
  height: number;
}

export const PatternList: FunctionComponent<PatternListProps> = ({
  configuration,
  width,
  height,
}) => {
  const { cid, printColors, printType } = configuration;
  const maxSize = Math.max(width, height);
  return (
    <Fragment>
      {printColors.map((printColor, index) => (
        <Fragment key={index}>
          {getIsSpecialPatternColor(printType, printColor.id) && (
            <pattern id={getPatternId(cid, index)} width="1" height="1">
              <image
                xlinkHref={getPatternImageHref(printType, printColor.id!)}
                width={maxSize}
                height={maxSize}
              />
            </pattern>
          )}
        </Fragment>
      ))}
    </Fragment>
  );
};
